import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

export default function FloatingWhatsApp() {
  const { waLink } = useSettings();
  return (
    <a
      href={waLink("Hi KIRAQ, I'd like to know more about your pieces")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-50 w-12 h-12 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(37,211,102,0.35)] transition-all duration-300 hover:scale-105"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={22} />
    </a>
  );
}
